/**
 * A text cell a spreadsheet would read as a formula: one that starts with `=`, `+`, `-` or `@`,
 * or their full-width forms (`＝＋－＠`, which some spreadsheets read the same), or a tab, a
 * carriage return or a line feed (which some skip before reading one): OWASP's CSV injection
 * set. A person's name, a service type or a customer's own words are anyone's to type
 * (`=HYPERLINK(…)`, "- Misc"), and quoting does not stop Excel or Sheets from running it.
 * Every CSV this product writes prefixes such a cell with `'`.
 */
export const CSV_FORMULA_START = /^[=+\-@＝＋－＠\t\r\n]/;
